<template>
  <div>
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>Birth</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="epdData"
        :items-per-page="10"
        hide-default-footer
      >
        <template v-slot:header.birth_weight="{}">
          <span class="">Weight({{ weightUnit }})</span>
        </template>
        <template v-slot:header.adjusted_birth_weight="{}">
          <span class="">Adjusted Weight({{ weightUnit }})</span>
        </template>
        <template v-slot:item.status="{}">
          <v-btn rounded dense small class="green2" outlined color="primary"
            >Active</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>Weaning</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="weaningHeaders"
        :items="epdData"
        :items-per-page="10"
        hide-default-footer
      >
        <template v-slot:header.weaning_weight="{}">
          <span class="">Weight({{ weightUnit }})</span>
        </template>
        <template v-slot:header.adjusted_weaning_weight="{}">
          <span class="">Adjusted Weight({{ weightUnit }})</span>
        </template>
        <template v-slot:item.status="{}">
          <v-btn rounded dense small class="green2" outlined color="primary"
            >Active</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>Yearling</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="yearlingHeaders"
        :items="epdData"
        :items-per-page="10"
        hide-default-footer
      >
        <template v-slot:header.yearling_weight="{}">
          <span class="">Weight({{ weightUnit }})</span>
        </template>
        <template v-slot:header.adjusted_yearling_weight="{}">
          <span class="">Adjusted Weight({{ weightUnit }})</span>
        </template>
        <template v-slot:item.status="{}">
          <v-btn rounded dense small class="green2" outlined color="primary"
            >Active</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AnimalService from "@/_services/AnimalService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  props: {
    epdId: Number,
  },
  async mounted() {
    this.startLoading();
    const performance = await AnimalService.getPerformance(this.epdId);
    if (performance?.data) {
      const performanceData = performance?.data?.getPerformance;
      this.animal.weightUnit = performanceData?.weightUnit;
      this.epdData[0].adjusted_birth_weight =
        performanceData?.adjusted_birth_weight || "-";
      this.epdData[0].adjusted_weaning_weight =
        performanceData?.adjusted_weaning_weight || "-";
      this.epdData[0].adjusted_yearling_weight =
        performanceData?.adjusted_yearling_weight || "-";
      this.epdData[0].birth_contemporary =
        performanceData?.birth_weight_cg || "-";
      this.epdData[0].birth_date = performanceData?.birthDate || "-";
      this.epdData[0].birth_weight = performanceData?.birth_weight || "-";
      this.epdData[0].weaning_contemporary =
        performanceData?.weaning_weight_cg || "-";
      this.epdData[0].weaning_date = performanceData?.weaning_date || "-";
      this.epdData[0].weaning_weight = performanceData?.weaning_weight || "-";
      this.epdData[0].yearling_contemporary =
        performanceData?.yearling_weight_cg || "-";
      this.epdData[0].yearling_date = performanceData?.yearling_date || "-";
      this.epdData[0].yearling_weight = performanceData?.yearling_weight || "-";
      this.epdData[0].ratio = performanceData?.ratio || "-";
      this.epdData[0].FrameScore = performanceData?.FrameScore || "-";
      this.epdData[0].ScrotalCircumference =
        performanceData?.scrotal_circumference || "-";
      this.epdData[0].calvingEase = performanceData?.calvingEase || "-";
      this.epdData[0].ctg = performanceData?.ctg || "-";

      this.loading = false;
    } else if (performance?.errors) {
      this.loading = false;

      console.log(performance?.errors);
    }
    this.stopLoading();
  },
  computed: {
    weightUnit() {
      console.log("----------> ", this.animal.weightUnit);
      return (this.animal.weightUnit || "lbs").toLowerCase();
    },
  },
  data() {
    return {
      animal: {
        weightUnit: "lbs",
      },
      epdData: [
        {
          adjusted_birth_weight: "-",
          adjusted_weaning_weight: "-",
          adjusted_yearling_weight: "-",
          birth_contemporary: "-",
          birth_date: "-",
          birth_weight: "-",
          weaning_contemporary: "-",
          weaning_date: "-",
          weaning_weight: "-",
          yearling_contemporary: "-",
          yearling_date: "-",
          yearling_weight: "-",
          ratio: "-",
          FrameScore: "-",
          ScrotalCircumference: "-",
          calvingEase: "-",
          ctg: "-",
        },
      ],
      headers: [
        {
          text: this.$t("Birth Date"),
          value: "birth_date",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Weight (lb) "),
          value: "birth_weight",
          sortable: false,
          align: "start",
          class: "black--text ",
          width: "10%",
        },
        {
          text: this.$t("Adjusted Weight (lb)"),
          value: "adjusted_birth_weight",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Ratio"),
          value: "ratio",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Calving Ease Score"),
          value: "calvingEase",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Contemporary Group"),
          value: "ctg",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
      ],
      weaningHeaders: [
        {
          text: this.$t("Date"),
          value: "weaning_date",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Weight (lb) "),
          value: "weaning_weight",
          sortable: false,
          align: "start",
          class: "black--text ",
          width: "10%",
        },
        {
          text: this.$t("Adjusted Weight (lb)"),
          value: "adjusted_weaning_weight",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Ratio"),
          value: "ratio",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Scrotal Circumference"),
          value: "ScrotalCircumference",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Contemporary Group"),
          value: "weaning_contemporary",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Frame Score"),
          value: "FrameScore",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
      ],
      yearlingHeaders: [
        {
          text: this.$t("Date"),
          value: "yearling_date",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Weight (lb) "),
          value: "yearling_weight",
          sortable: false,
          align: "start",
          class: "black--text ",
          width: "10%",
        },
        {
          text: this.$t("Adjusted Weight (lb)"),
          value: "adjusted_yearling_weight",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Ratio"),
          value: "ratio",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Scrotal Circumference"),
          value: "ScrotalCircumference",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Contemporary Group"),
          value: "yearling_contemporary",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Frame Score"),
          value: "FrameScore",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>
